import $ from 'jquery';

/* Accordion */
function glbt_accordion() {
  $('.ac_wrap ').each(function () {
    const tabid = $(this).attr('id');
    $("#" + tabid + " .ac_content:not('.active')").hide();
  });

  $(".ac_wrap .ac_title").on('click',function () {
    $(this).next(".ac_content").slideToggle(400, 'swing').siblings(".ac_content:visible").slideUp(400, 'swing');
    $(this).toggleClass("active");
    $(this).siblings(".ac_title").removeClass("active");
  });
}

glbt_accordion();